module.exports = __webpack_public_path__ + "img/header-engagementRingsDainty.42b3e12.webp";